import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'input:not([autocomplete])',
})
export class AutocompleteOffDirective {
  @HostBinding('attr.autocomplete') autocomplete = 'off';
}
